import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsAnalyticsProjectsReportsTopRisksReportsExportProcessMutation() {
  return useMutation({
    mutationKey: [
      'createProjectsAnalyticsProjectsReportsTopRisksReportsExportProcess',
    ],
    mutationFn: async ({ params }) => {
      const response = await axios.post(
        '/projects_analytics/projects_reports/top_risks_reports/export_processes',
        { export_process: params },
      );

      return response.data;
    },
  });
}
